import { render, staticRenderFns } from "./OmnichannelIndividualParamsModal.vue?vue&type=template&id=a5db26ae&scoped=true"
import script from "./OmnichannelIndividualParamsModal.vue?vue&type=script&lang=ts"
export * from "./OmnichannelIndividualParamsModal.vue?vue&type=script&lang=ts"
import style0 from "./OmnichannelIndividualParamsModal.vue?vue&type=style&index=0&id=a5db26ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5db26ae",
  null
  
)

export default component.exports